import React, { Component } from "react";
import ReactToPrint from "react-to-print";
import { PriceFormat } from "../scripts/helpers";

class FactorPrint extends Component {
  state = {
    factor: [],
    newRow: [],
    orderItem: [],
  };
  handlePrice = (a, b) => {
    const sum = parseInt(a) + parseInt(b);
    return PriceFormat(sum);
  };
  render() {
    const { detail } = this.props;
    return (
      <div className="container container-print pb-3">
        <div className="col-12">
          <div className="row">
            <div className="col-12 pt-5 text-center">
              <h4>فروشگاه دماوند</h4>
            </div>
            <div className="col-12 text-center">
              <table className="table table-bordered w-100 mt-5">
                <tbody>
                  <tr className="text-center">
                    <th className="text-center">نام مشتری:</th>
                    <th className="text-center">{`${detail.user.name} ${detail.user.family}`}</th>
                  </tr>
                  <tr className="text-center">
                    <th className="text-center">تلفن مشتری:</th>
                    <th className="text-center">{detail.user.phone}</th>
                  </tr>
                  <tr className="text-center">
                    <th className="text-center">آدرس:</th>
                    <th className="text-center">{detail.address}</th>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col-12">
              <table className="table table-bordered w-100 mt-2">
                <thead>
                  <tr className="text-center">
                    <th className="text-center">تامین کننده</th>
                    <th className="text-center">کالا</th>
                    <th className="text-center">تعداد</th>
                    <th className="text-center">قیمت پایه</th>
                    <th className="text-center">قیمت نهایی</th>
                  </tr>
                </thead>
                <tbody>
                  {detail.product.map((item, i) => (
                    <tr key={`key:${i}`}>
                      <th className="text-center">
                        {
                          (item?.supplier) ? item?.supplier?.name + " "+ item?.supplier.family: ""
                        },
                       </th>
                      <th className="text-center">
                        {item.name + "-" + item.code}
                      </th>
                      <th className="text-center">{item.pivot.count}</th>
                      <th className="text-center">
                        {PriceFormat(item.pivot.price)}
                      </th>
                      <th className="text-center">
                        {PriceFormat(item.pivot.price * item.pivot.count)}
                      </th>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th className="text-center">جمع کل</th>
                    <th colSpan="3" className="text-center">
                      {PriceFormat(detail.total)}
                    </th>
                  </tr>
                  <tr>
                    <th className="text-center">هزینه ارسال</th>
                    <th colSpan="3" className="text-center">
                      {PriceFormat(detail.transferringCost)}
                    </th>
                  </tr>
                  <tr>
                    <th className="text-center">مبلغ کل</th>
                    <th colSpan="3" className="text-center">
                      {PriceFormat(
                        this.handlePrice(detail.total, detail.transferringCost)
                      )}
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class PrintComponent extends React.Component {
  render() {
    return (
      <div className="container text-center">
        <div className="row">
          <div className="col-md-12">
            <FactorPrint
              detail={this.props.printDetail}
              ref={(el) => (this.componentRef = el)}
            />
          </div>
          <div className="col-md-12">
            <ReactToPrint
              // copyStyles
              trigger={() => (
                <button
                  data-dismiss="modal"
                  className="btn btn-none-box btn-info border-radius-lg border-md color-light mt-5"
                >
                  پرینت فاکتور
                </button>
              )}
              bodyClass="rtl"
              content={() => this.componentRef}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default PrintComponent;
